import React from 'react';
import SelectField from '../../forms/selectOption';
import { MODALS } from '../../../config/images';
import time from "../../../assets/images/icons/shared/timemodal.svg";
const EditTimeSlotModal = ({
  isOpen,
  onClose,
  startTime,
  endTime,
  onStartTimeClick,
  onEndTimeClick,
  queueSupplier,
  onQueueSupplierChange,
  onSave,
  isSubmitting,
  title = "Editar horario"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[35%] w-[85%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4">
        <div className='flex justify-end'>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>

        <div className='flex flex-col w-full gap-3 px-4'>
          <h3 className="text-[15px] font-itcdemi text-blue">{title}</h3>
          
          <div className="flex flex-col gap-2">
            <p className="text-sm font-itcdemi">Seleccione un rango de horas <span className="text-red-500">*</span></p>
      
            <div className="flex items-center gap-2">
              <button
                onClick={onStartTimeClick}
                className="w-full flex items-center justify-between gap-2 p-2 px-3 border border-[#D1D5DB] rounded-md"
              >
                <p className="font-itcbook text-sm text-[#6B7280]">
                  {startTime ? startTime.substring(0, 5) : "Seleccione hora inicial"}
                </p>
                <img src={time} alt="Tiempo"/>
              </button>
        
              <button
                onClick={onEndTimeClick}
                className="w-full flex items-center justify-between gap-2 p-2 px-3 border border-[#D1D5DB] rounded-md"
              >
                <p className="font-itcbook text-sm text-[#6B7280]">
                  {endTime ? endTime.substring(0, 5) : "Seleccione hora final"}
                </p>
                <img src={time} alt="Tiempo"/>
              </button>
            </div>
          </div>
          
          <div className="flex flex-col gap-2">
            <p className="text-sm font-itcdemi">Cantidad de proveedores <span className="text-red-500">*</span></p>
            <SelectField
              name="queueSupplier"
              value={queueSupplier?.toString() || ""}
              onChange={(e) => onQueueSupplierChange(parseInt(e.target.value))}
              width="w-full"
              placeholder="Escoja número"
              options={[
                { value: "1", label: "1 proveedor" },
                { value: "2", label: "2 proveedores" },
                { value: "3", label: "3 proveedores" },
                { value: "4", label: "4 proveedores" },
                { value: "5", label: "5 proveedores" },
                { value: "6", label: "6 proveedores" },
                { value: "7", label: "7 proveedores" },
                { value: "8", label: "8 proveedores" },
                { value: "9", label: "9 proveedores" },
                { value: "10", label: "10 proveedores" }
              ]}
              disabled={isSubmitting}
            />
          </div>
            
          <div className="flex justify-center">
            <button
              onClick={onSave}
              className="underline text-[15px] font-itcbook text-blue disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTimeSlotModal;